<template>
    <daterange-m :_start="startDate" :_end="endDate" @change-start="changeStart" @change-end="changeEnd" />
</template>

<script lang="ts">
    import {Vue, Component, Prop, Emit} from 'vue-facing-decorator'
    import DaterangeM from '~src/components/search/forms/daterangeM.src'

    @Component({
        components: {DaterangeM},
    })
    export class ActivitySearchDatepicker extends Vue {
        @Prop({required: true}) startDate: string
        @Prop({required: true}) endDate: string

        @Emit()
        changeStart(startDate: string) {
            return startDate
        }

        @Emit()
        changeEnd(endDate: string) {
            return endDate
        }
    }

    export default ActivitySearchDatepicker
</script>
